import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getTagStatus, getTagError } from '@store/reducers/blog/selectors';
import { createTag } from '@store/actions/blog';
import { getPermittedPermissions } from '@store/reducers/check-permission/selectors';
import Main from './Main';

const mapStateToProps = state => ({
  status: getTagStatus(state),
  permittedPermissions: getPermittedPermissions(state),
  errors: getTagError(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createTag,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
